import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import Rails from '@rails/ujs';
import AsyncFileUpload from './modules/async-file-upload';
import FileOrganizer from './modules/file-organizer';
import ConditionalContent from './modules/conditional-content';
import CharacterCounter from './modules/character-counter';

if (process.env.ENABLE_SENTRY_INTEGRATION === 'true') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

Rails.start();

const modules = [
  {
    name: 'async-file-upload',
    class: AsyncFileUpload,
    options: {},
  },
  {
    name: 'file-organizer',
    class: FileOrganizer,
    options: {},
  },
  {
    name: 'conditional-content',
    class: ConditionalContent,
    options: {},
  },
  {
    name: 'character-counter',
    class: CharacterCounter,
    options: {},
  },
];

modules.forEach(function(config) {
  const selector = `[data-module*="${config.name}"]`;

  [].slice.call(document.querySelectorAll(selector)).forEach(function(element) {
    new config.class(element, selector, config.options);
  });
});
